/* Hangolas — huzhato dimenzio-skala.
   A forras DesignCraft-reaktiv komponens volt (support.js runtime, {{ dim }} / {{ tuneCopy }} bindingok).
   A runtime NEM kerult at; ez a fajl ugyanazt a logikat adja vissza vanilla JS-ben:
     - a huzas Pointer Events-en megy, ezert az erintes es az eger UGYANAZT az agat hasznalja
     - a lepcsok kozul mindig a legkozelebbi aktiv (a makett "nearest stop" logikaja)
     - billentyuzettel is lepteheto (a makettben ez nem volt benne — akadalymentesseg)
   Section-scope-olt: minden [data-hs] gyokerre kulon init, es a shopify:section:load-ra ujra. */
(function () {
  'use strict';

  function initHs(root) {
    if (!root || root.__hsInit) return;
    var track = root.querySelector('[data-hs-track]');
    var knob = root.querySelector('[data-hs-knob]');
    var num = root.querySelector('[data-hs-num]');
    var copy = root.querySelector('[data-hs-copy]');
    var ticksWrap = root.querySelector('[data-hs-ticks]');
    var dataEl = root.querySelector('[data-hs-steps]');
    if (!track || !knob || !num || !copy || !dataEl) return;

    var steps;
    try { steps = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!steps || steps.length < 2) return;

    root.__hsInit = true;

    var ticks = ticksWrap ? [].slice.call(ticksWrap.querySelectorAll('.hs__tick')) : [];
    ticks.forEach(function (t, i) { if (i % 5 === 0) t.classList.add('is-major'); });

    var utolso = steps.length - 1;
    var v = parseFloat(track.getAttribute('data-hs-init') || '0') / utolso;
    if (isNaN(v)) v = 0;
    var huzas = false;

    /* A lathato ertek mindig a legkozelebbi lepcso — a csuszka folytonos, a tartalom lepcsos. */
    function index() {
      var i = Math.round(v * utolso);
      return Math.max(0, Math.min(utolso, i));
    }

    function rajzol() {
      var i = index();
      knob.style.left = 'calc(' + (v * 100).toFixed(2) + '% - 15px)';
      num.textContent = steps[i].d;
      copy.textContent = steps[i].t;
      track.setAttribute('aria-valuenow', String(i));
      track.setAttribute('aria-valuetext', steps[i].d);
      for (var k = 0; k < ticks.length; k++) {
        var frac = k / (ticks.length - 1);
        ticks[k].classList.toggle('is-on', frac <= v + 0.001);
      }
    }

    function ertekEsemenybol(e) {
      var r = track.getBoundingClientRect();
      if (!r.width) return;
      v = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      rajzol();
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      huzas = true;
      track.classList.add('is-drag');
      if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
      ertekEsemenybol(e);
      e.preventDefault();
    });

    track.addEventListener('pointermove', function (e) { if (huzas) ertekEsemenybol(e); });

    function elenged() {
      if (!huzas) return;
      huzas = false;
      track.classList.remove('is-drag');
      /* elengedesnel a csuszka a legkozelebbi lepcsore ul be — kulonben a gomb es a szoveg elvalna */
      v = index() / utolso;
      rajzol();
    }
    track.addEventListener('pointerup', elenged);
    track.addEventListener('pointercancel', elenged);
    track.addEventListener('pointerleave', elenged);

    track.addEventListener('keydown', function (e) {
      var i = index();
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { i = Math.min(utolso, i + 1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { i = Math.max(0, i - 1); }
      else if (e.key === 'Home') { i = 0; }
      else if (e.key === 'End') { i = utolso; }
      else { return; }
      e.preventDefault();
      v = i / utolso;
      rajzol();
    });

    rajzol();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-hs]');
    Array.prototype.forEach.call(roots, initHs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target || document;
    var root = el.querySelector ? el.querySelector('[data-hs]') : null;
    if (root) { root.__hsInit = false; initHs(root); }
  });
})();
